// 高保真保护区滚动与页级状态的纯函数，方便用最小脚本做回归校验。
export const PAGE_SYNC_OFFSET = 50
export const LAST_PAGE_SCROLL_BUFFER = 20

export function clampPage(page, pageCount) {
	const safeCount = Math.max(1, Number(pageCount) || 1)
	return Math.min(Math.max(1, Number(page) || 1), safeCount)
}

export function buildPageTopsFromHeights(pageHeights, pageCount) {
	const result = []
	let top = 0
	for (let page = 1; page <= pageCount; page += 1) {
		result.push(top)
		top += Number(pageHeights?.[page]) || 0
	}
	return result
}

export function getPageScrollTop(pageTops, page) {
	if (!Array.isArray(pageTops) || pageTops.length === 0) return 0
	const targetPage = clampPage(page, pageTops.length)
	return Math.max(0, Number(pageTops[targetPage - 1]) || 0)
}

export function resolveCurrentPageFromScroll({
	scrollTop,
	clientHeight,
	scrollHeight,
	pageTops,
	offset = PAGE_SYNC_OFFSET,
}) {
	if (!Array.isArray(pageTops) || pageTops.length === 0) return 1
	const pageCount = pageTops.length
	const safeScrollTop = Math.max(0, Number(scrollTop) || 0)
	const safeClientHeight = Math.max(0, Number(clientHeight) || 0)
	const safeScrollHeight = Math.max(0, Number(scrollHeight) || 0)

	// 滚动到底部留白时仍保持最后一页选中，避免空白区反算到上一页。
	if (safeScrollHeight > 0 && safeScrollTop + safeClientHeight >= safeScrollHeight - 2) {
		return pageCount
	}

	const probeTop = safeScrollTop + offset
	let currentPage = 1
	for (let index = 0; index < pageCount; index += 1) {
		if (probeTop >= (Number(pageTops[index]) || 0)) {
			currentPage = index + 1
		}
	}
	return clampPage(currentPage, pageCount)
}

export function getLastPageBottomMargin(containerHeight, lastPageHeight, buffer = LAST_PAGE_SCROLL_BUFFER) {
	const safeContainerHeight = Math.max(0, Number(containerHeight) || 0)
	const safeLastPageHeight = Math.max(0, Number(lastPageHeight) || 0)
	const safeBuffer = Math.max(0, Number(buffer) || 0)
	return Math.max(safeBuffer, safeContainerHeight - safeLastPageHeight + safeBuffer)
}

export function resolvePageLayoutMetrics({
	measuredTops,
	measuredHeights,
	pageHeights,
	pageCount,
	containerHeight,
	buffer = LAST_PAGE_SCROLL_BUFFER,
}) {
	const safePageCount = Math.max(0, Number(pageCount) || 0)
	const normalizedMeasuredTops = Array.isArray(measuredTops) && measuredTops.length >= safePageCount
		? measuredTops.slice(0, safePageCount)
		: []
	const normalizedMeasuredHeights = Array.isArray(measuredHeights) && measuredHeights.length >= safePageCount
		? measuredHeights.slice(0, safePageCount)
		: []
	const pageTops = normalizedMeasuredTops.length === safePageCount
		? normalizedMeasuredTops
		: buildPageTopsFromHeights(pageHeights, safePageCount)
	const measuredLastPageHeight = normalizedMeasuredHeights.length === safePageCount
		? Number(normalizedMeasuredHeights[safePageCount - 1]) || 0
		: 0
	const lastPageBottomMargin = safePageCount > 0
		? getLastPageBottomMargin(containerHeight, measuredLastPageHeight || Number(pageHeights?.[safePageCount]) || 0, buffer)
		: 0

	return {
		pageTops,
		lastPageBottomMargin,
	}
}

export function isPageFlagSelected(pageFlagStatus, page) {
	return Boolean(pageFlagStatus?.[Number(page)])
}

export function buildPageFlagStatusFromEditJson(editJson) {
	const result = {}
	if (!editJson || typeof editJson !== 'object') return result
	Object.entries(editJson).forEach(([page, list]) => {
		if (Array.isArray(list) && list.some(item => item?.edit_rect_type === 'page')) {
			result[Number(page)] = true
		}
	})
	return result
}

export function buildPageFlagStatusFromJsonList(jsonList) {
	const result = {}
	if (!Array.isArray(jsonList)) return result
	jsonList.forEach(item => {
		if (item?.list?.some(entry => entry?.edit_rect_type === 'page')) {
			result[Number(item.page)] = true
		}
	})
	return result
}
